import { createFileRoute } from '@tanstack/react-router'
import SignInClerk from '@/features/auth/sign-in/sign-in-clerk'

export const Route = createFileRoute('/(auth)/sign-in')({
  component: SignInClerk,
})
